import { render, staticRenderFns } from "./WeekNumbers.vue?vue&type=template&id=e55fac4a&scoped=true"
import script from "./WeekNumbers.vue?vue&type=script&lang=js"
export * from "./WeekNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55fac4a",
  null
  
)

export default component.exports